import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';

import 'rxjs/add/operator/toPromise';
import { tap } from 'rxjs/operators';
import { User } from '../shared/model/user.model';
import { environment } from 'src/environments/environment';
import { Senha } from '../shared/model/senha.model ';

const API_URL_OAUTH = environment.mouraAmmServerURLOauth;
const API_URL_BASE = environment.mouraAmmServerURL;

@Injectable()
export class AuthService {

  private jwtPayload: any;

  private headers = new HttpHeaders().append('Authorization', environment.httpBasic)
      .append('Content-Type', 'application/x-www-form-urlencoded');

  constructor(private http: HttpClient, private jwtHelper: JwtHelperService) {
    this.carregarToken();
  }

  login(userName: string, password: string) {
    const body = `username=${userName}&password=${password}&grant_type=password`;
    return this.http.post(API_URL_OAUTH, body, {headers : this.headers, withCredentials: true})
      .pipe(tap(response => {
          this.armazenarToken(response['access_token']);
      }));
  }

  esqueceuSenha(email: string) {
    return this.http.post(`${API_URL_BASE}/usuarios/esqueceu-senha`, email,
                {headers : new HttpHeaders().append('Content-Type', 'application/json')}
    );
  }

  getNovaSenha(strToken: string) {
    return this.http.get(`${API_URL_BASE}/usuarios/nova-senha/${strToken}`);
  }

  gerarNovaSenha(tokenURL: any, senha: Senha) {
    return this.http.put(`${API_URL_BASE}/usuarios/nova-senha/${tokenURL}`, senha,
                {headers : new HttpHeaders().append('Content-Type', 'application/json')}
    );
  }

  /**
   * Method responsible for returning logged user if there is one
   */
  getLoggedUser(): User | null {
    // get logged user from localstorage
    const loggedUserInformation: string = localStorage.getItem('token');
    if (loggedUserInformation !== null && loggedUserInformation.length > 0)  {
        // set the user object
        const payloadDecode = this.jwtHelper.decodeToken(loggedUserInformation);

        const user = new User();
        user.id = payloadDecode.id_usuario;
        user.name = payloadDecode.nome;
        user.email = payloadDecode.user_name;
        user.perfil = payloadDecode.perfil;

        return user;
    }
  }

  /*
   * Método para armazenar o token no localStorage
   * Chamando a função para decodificar o token
   */
  private armazenarToken(token: string) {
    this.jwtPayload = this.jwtHelper.decodeToken(token);
    localStorage.setItem('token', token);
    localStorage.setItem('emailUsuario', this.jwtPayload.email);
  }

  // Método para carregar o token toda vez que a aplicação é iniciada.
  private carregarToken() {
    const token = localStorage.getItem('token');

    if (token) {
      this.armazenarToken(token);
    }
  }

  // Método para validar se o usuário tem permissão para acessar através das authorities.
  temPermissao(permissao: string) {
    return this.jwtPayload && this.jwtPayload.authorities.includes(permissao);
  }

  // Método para validar as permissões do usuário.
  temQualquerPermissao(roles) {
    for (const role of roles) {
      if (this.temPermissao(role)) {
        return true;
      }
    }
    return false;
  }

  // Método para saber se o token está inválido.
  isAccessTokenInvalido() {
    const token = localStorage.getItem('token');
    return !token || this.jwtHelper.isTokenExpired(token);
  }

  // Método para fazer o logout.
  logout() {
    localStorage.removeItem('token');
    this.jwtPayload = null;
  }
}
